import { Helmet } from "react-helmet-async"
import { ISupplier, SupplierTripWiseBookings } from "../../../../../Supplier"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"
import { useOutletContext } from "react-router"

export default function SupplierBookingsPage() {
	const { transportServiceProvider } = useOutletContext<{
		transportServiceProvider: ISupplier
		revalidate: () => void
	}>()
	return (
		<ForbidUnlessAuthorized
			permission={PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS}
		>
			<Helmet>
				<title>Trip Wise Bookings | Supplier</title>
			</Helmet>
			<SupplierTripWiseBookings
				transportServiceProvider={transportServiceProvider}
			/>
		</ForbidUnlessAuthorized>
	)
}
